import { ValidationFunction } from '@/common/validation';

const errorMessage = 'To pole jest wymagane';

export const checked: ValidationFunction = value => {
	return !!value || errorMessage;
};
